import { render, staticRenderFns } from "./Cifras.vue?vue&type=template&id=30895792"
import script from "./Cifras.vue?vue&type=script&lang=js"
export * from "./Cifras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports